import { render, staticRenderFns } from "./BrandCompetitionSummary.vue?vue&type=template&id=396062c6&scoped=true&"
import script from "./BrandCompetitionSummary.vue?vue&type=script&lang=js&"
export * from "./BrandCompetitionSummary.vue?vue&type=script&lang=js&"
import style0 from "./BrandCompetitionSummary.vue?vue&type=style&index=0&id=396062c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396062c6",
  null
  
)

export default component.exports